"use strict";
import {findAll, trigger, setAttribute} from "@elements/dom-utils";
import TerracePlanner from "../index";
import Popover from 'bootstrap/js/dist/popover';

/**
 * Uses the configuration provided in TerracePlanner.inputDependencies to bind listeners to
 * independent input nodes to update dependent input nodes and has a change event fired on the latter.
 *
 * The configuration may change whenever a new outline template is loaded via AJAX.
 *
 * Storing independent nodes as jQuery objects somehow prevents the references to the actual Elements
 * from being updated
 *
 * This function has been transpiled from ES6 to work with outdated browsers
 * @see https://babeljs.io/repl
 *
 * @see TerracePlanner.js.html.php
 */
export function init() {
    //remove all open popovers from another module
    findAll('.js-planner__size-popover').map((popover) => {
        popover.remove();
    });

    for (let dependentDimension in TerracePlanner.inputDependencies) {
        let dependentNode = document.getElementById(dependentDimension);
        let independentNodes = [];

        for (let independentDimension in TerracePlanner.inputDependencies[dependentDimension]) {
            let independentNode = document.getElementById(independentDimension);

            if (null === independentNode) {
                continue;
            }

            independentNodes.push(independentNode);

            independentNode.addEventListener('input', function (event) {
                // let popoverInstance = Popover.getOrCreateInstance(event.target);
                let dependentPopoverInstance = Popover.getOrCreateInstance(dependentNode, {
                    customClass: 'js-planner__size-popover'
                });
                let sum = independentNodes.reduce(function(sum, node) {
                    return sum + Number(node.value.replace(',','.'));
                }, 0);

                if (sum > TerracePlanner.MAX_SIDE_LENGTH) {
                    event.preventDefault();

                    event.target.value = event.target.getAttribute('data-previous-value');

                    dependentPopoverInstance.show();
                    return;
                }

                setAttribute('data-previous-value', event.target.value, event.target);
                dependentNode.value = Math.round(sum * 1000) / 1000;


                dependentPopoverInstance.hide();

                trigger('input', dependentNode);
            });
        }
    }
}